import * as React from 'react';

function MiddleGrayCardIcon({ 'aria-hidden': ariaHidden = true, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="85"
      height="85"
      viewBox="0 0 85 85"
      aria-hidden={ariaHidden}
      {...props}
    >
      <defs>
        <path
          id="wf23yxpvda"
          d="M38.958 0c5.868 0 10.625 4.757 10.625 10.625v49.583c0 5.868-4.757 10.625-10.625 10.625H10.625C4.757 70.833 0 66.076 0 60.208V10.625C0 4.757 4.757 0 10.625 0h28.333zm7.084 15.916C36.169 5.878 21.25 10.76 21.25 25.186c0 14.425 24.792 30.167 24.792 30.167V15.916z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <path d="M0 0H85V85H0z" transform="translate(-677 -200) translate(677 200)" />
            <g transform="translate(-677 -200) translate(677 200) translate(17.708 7.083)">
              <mask id="89w4l97kqb" fill="#fff">
                <use xlinkHref="#wf23yxpvda" />
              </mask>
              <use fill="#383C52" fillRule="nonzero" xlinkHref="#wf23yxpvda" />
              <g fill="#D7D8DC" mask="url(#89w4l97kqb)">
                <path d="M0 0H85V85H0z" transform="translate(-17.708 -7.083)" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default MiddleGrayCardIcon;
